<template>
  <div
    v-bind:style="showModalContainers ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4
            class="modal-title"
          >Contenedores - Recalada {{recalada}}</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body modal-dialog-scrollable">
          <ul class="list-group">
            <li v-for="(ctn, k) in containers" :key="k" class="list-group-item d-flex justify-content-between align-items-center">
              {{ctn.number}}
              <span><button class="btn btn-warning" v-if="!ctn.used" @click="removeContainer(ctn)"><i class="fa fa-trash" /></button></span>
              <h5><span :class="`badge badge-${ctn.dead_freight ? 'danger' : (ctn.used ? 'success' : 'primary')} badge-pill`"><i :class="`fa fa-${ctn.dead_freight ? 'random' : (ctn.used ? 'check' : 'cog')}`"/> {{ctn.dead_freight ? 'Falso flete' : (ctn.used ? 'Completado' : 'Pendiente')}}</span></h5>
            </li>
          </ul>
        </div>
        <div class="modal-footer">
          <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  name: "ModalContainers",
  props: [
    "showModalContainers",
    "containers",
    "recalada"
  ],
  data() {
    return {
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    removeContainer(ctn){
      if(confirm(`¿Seguro desea eliminar contenedor ${ctn.number}?`)){
        api.delete(`/portage_container/${ctn.id}`).then(response => {
          if(response.success){
            this.$toastr.success('Contenedor eliminado', 'Contenedor', {
              positionClass: "toast-top-center",
              closeButton: true
            });
            this.$emit("removeContainer", ctn.id);
          } else {
            this.$toastr.error('No es posible eliminar el contenedor debido a que está en proceso o ya fue procesado', 'Contenedor', {
              positionClass: "toast-top-center",
              closeButton: true
            });
          }
        })
      }
    }
  }
};
</script>
<style scoped>
.modal-dialog-scrollable {
  height: 450px;
  overflow: scroll;
}
</style>
